<template>
  <v-row justify="center" no-gutters>
    <v-col cols="12" lg="9">
      <div class="shop-announce ql-editor" style="font-size: 13px; padding: 0;" v-html="html"/>
    </v-col>
  </v-row>
</template>

<script>
import PartBase from '@/mixins/PartBase'
import 'quill/dist/quill.core.css'

export default {
  name: 'ShopAnnounce',
  mixins: [
    PartBase
  ],
  props: {
    html: {
      type: String,
      required: true
    }
  }
}
</script>
